import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './en.json';
import tr from './tr.json';
import es from './es.json';
import pt from './pt.json';
import de from './de.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import ru from './ru.json';
import uk from './uk.json';
import ar from './ar.json';
import id from './id.json';

export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'uk', name: 'Українська', flag: '🇺🇦' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' },
  { code: 'id', name: 'Indonesia', flag: '🇮🇩' },
];

// URL path translations per language
export const PATH_TRANSLATIONS = {
  en: { match: 'match', league: 'league', team: 'team', bookmaker: 'bookmaker', valueBets: 'value-bets', surebets: 'surebets', oddsMovements: 'odds-movements', search: 'search', live: 'live', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  tr: { match: 'mac', league: 'lig', team: 'takim', bookmaker: 'bahisci', valueBets: 'deger-bahisleri', surebets: 'kesin-bahisler', oddsMovements: 'oran-hareketleri', search: 'arama', live: 'canli', worldcup: 'dunya-kupasi-2026', football: 'futbol', basketball: 'basketbol' },
  es: { match: 'partido', league: 'liga', team: 'equipo', bookmaker: 'casa-apuestas', valueBets: 'apuestas-valor', surebets: 'apuestas-seguras', oddsMovements: 'movimientos-cuotas', search: 'buscar', live: 'en-vivo', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  pt: { match: 'jogo', league: 'liga', team: 'equipe', bookmaker: 'casa-apostas', valueBets: 'apostas-valor', surebets: 'apostas-seguras', oddsMovements: 'movimentos-odds', search: 'buscar', live: 'ao-vivo', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  de: { match: 'spiel', league: 'liga', team: 'team', bookmaker: 'buchmacher', valueBets: 'wertquoten', surebets: 'sichere-wetten', oddsMovements: 'quotenbewegungen', search: 'suche', live: 'live', worldcup: 'world-cup-2026', football: 'fussball', basketball: 'basketball' },
  fr: { match: 'match', league: 'ligue', team: 'equipe', bookmaker: 'bookmaker', valueBets: 'paris-valeur', surebets: 'paris-surs', oddsMovements: 'mouvements-cotes', search: 'recherche', live: 'en-direct', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  it: { match: 'partita', league: 'campionato', team: 'squadra', bookmaker: 'bookmaker', valueBets: 'scommesse-valore', surebets: 'scommesse-sicure', oddsMovements: 'movimenti-quote', search: 'cerca', live: 'dal-vivo', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  nl: { match: 'wedstrijd', league: 'competitie', team: 'team', bookmaker: 'bookmaker', valueBets: 'waarde-weddenschappen', surebets: 'zekere-weddenschappen', oddsMovements: 'odds-bewegingen', search: 'zoeken', live: 'live', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  ru: { match: 'match', league: 'liga', team: 'komanda', bookmaker: 'bukmeker', valueBets: 'stavki-cennost', surebets: 'vernye-stavki', oddsMovements: 'dvizhenie-koeffitsientov', search: 'poisk', live: 'live', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  uk: { match: 'match', league: 'liga', team: 'komanda', bookmaker: 'bukmeker', valueBets: 'tsinnisni-stavky', surebets: 'virni-stavky', oddsMovements: 'rukh-koefitsiyentiv', search: 'poshuk', live: 'live', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  ar: { match: 'mubarat', league: 'dawri', team: 'fariq', bookmaker: 'murahan', valueBets: 'rahanat-qiyma', surebets: 'rahanat-akida', oddsMovements: 'harakat-ihtimalat', search: 'bahth', live: 'mubashir', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
  id: { match: 'pertandingan', league: 'liga', team: 'tim', bookmaker: 'bandar', valueBets: 'taruhan-nilai', surebets: 'taruhan-pasti', oddsMovements: 'pergerakan-odds', search: 'cari', live: 'langsung', worldcup: 'world-cup-2026', football: 'football', basketball: 'basketball' },
};

// World Cup sub-path translations
export const WC_EN_TO_TR = {
  'world-cup-2026': 'dunya-kupasi-2026', 'host': 'ev-sahibi', 'stadium': 'stadyum',
  'scores': 'skor-ve-fikstur', 'groups': 'gruplar', 'teams': 'takimlar',
  'turkey': 'turkiye', 'cities': 'sehirler', 'stadiums': 'stadyumlar',
  'tickets': 'bilet-satis', 'fixtures': 'fikstur', 'group': 'grup',
  'match': 'mac', 'team': 'takim',
  'usa': 'abd', 'canada': 'kanada', 'mexico': 'meksika',
};
export const WC_TR_TO_EN = Object.fromEntries(Object.entries(WC_EN_TO_TR).map(([k, v]) => [v, k]));

export const DEFAULT_LANGUAGE = 'en';

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, tr: { translation: tr }, es: { translation: es }, pt: { translation: pt }, de: { translation: de }, fr: { translation: fr }, it: { translation: it }, nl: { translation: nl }, ru: { translation: ru }, uk: { translation: uk }, ar: { translation: ar }, id: { translation: id } },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
